import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { isSourceImageVertical } from '@wix/da-shared-react/pkg/DeviationViews/Dumbo/Image/_helpers';
import { AppState } from '../../../../../types/store';
import {
  updateCoverDeviation,
  updateCoverDeviationOffsetY,
  deleteCoverDeviation,
} from '../../../../actions/deviations';
import {
  FirstTimeFlag,
  dropFirstTimeFlag,
} from '@wix/da-shared-react/pkg/redux/firstTimeFlags';
import { getCoverDeviation } from '../../../../selectors/deviations';
import { getModuleIdByModuleType } from '../../../../selectors/modules';
import { ModuleType } from '../../../../../types/modules';

import { Props } from './ProfileHeroEdit';

type StateProps = Pick<
  Props,
  'coverDeviation' | 'withPositionManager' | 'showWatchIntro' | 'moduleId'
>;
type DispatchProps = Pick<
  Props,
  | 'updateCoverDeviation'
  | 'deleteCoverDeviation'
  | 'updateCoverDeviationOffsetY'
  | 'dropProfileEditAidFlag'
>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const coverDeviation = getCoverDeviation(state);
  const showWatchIntro =
    !ownProps.showProfileHeroAid && ownProps.showProfileEditAid;
  const moduleId = getModuleIdByModuleType(state, ModuleType.COVER_DEVIATION);

  return {
    coverDeviation,
    withPositionManager: isSourceImageVertical(coverDeviation),
    showWatchIntro,
    moduleId,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  updateCoverDeviation,
  deleteCoverDeviation,
  updateCoverDeviationOffsetY,
  dropProfileEditAidFlag: () =>
    dropFirstTimeFlag({ flag: FirstTimeFlag.ProfileEditAidNotClosed }),
};

export default connect(mapStateToProps, mapDispatchToProps);
